import { Queries } from "../services/queries";
import Popup from 'reactjs-popup';
import React, { useState } from "react";
import {WEBSERVER} from "../services/globals";



 export default function PlaceCartComponent({idnr ,qty, func, select}) {

  let cnt:number  = parseInt(qty);
 
  function gotocart() {
    window.location.href=`${WEBSERVER}/cart`;
  }
  let disabled:string = "btn btn-primary incartbutton disabled";

  //ohne Listbox "disabled" entfernen
  if (select == null) {
    disabled = "btn btn-primary incartbutton";
  }

  function handleClick() {
 

    if (select != null) {
       idnr = (document.getElementById(select) as HTMLInputElement).value;
    } else {
      disabled = "btn btn-primary incartbutton";
    } 
    const queries = new Queries();
    const response = queries.placeCart(idnr,cnt);

    func(); //inc cartcount
    



//  console.log('\n+++placecart++++++++',JSON.stringify(response));
  }

  const [open, setOpen] = useState(false);
  const closeModal = () => setOpen(false);

  //console.log("product:~~~~~~~~" +  JSON.stringify(product));
  

  let cname="id_" + idnr;
     return  ( <div>
      <button className={disabled} id={cname} onClick={() => {handleClick(); setOpen(o => !o) }}>in Warenkorb</button>
      <Popup open={open} closeOnDocumentClick onClose={closeModal} className="">
                <div className="modalx animate">
  <div className="text-center">Artikel ist im Warenkorb</div><h1 className="text-center"><i className="bi bi-check font-weight-bold"></i></h1>
  <div className="d-flex justify-content-between">
  <button className="btn btn-secondary" onClick={closeModal}>weiter einkaufen</button>
  &nbsp;
  <button className="btn btn-primary" onClick={gotocart}>zum Warenkorb</button>
  </div>
     </div>
   </Popup>
      </div>);
  
 };
 
